import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  variant?: 'default' | 'compact' | 'featured';
}

export default function MovieCard({ movie, variant = 'default' }: MovieCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="group block cursor-pointer"
      >
        <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-2">
          <img
            src={movie.imageUrl}
            alt={movie.title}
            title={`${movie.title} - 人人影院高清免费在线观看`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
          {movie.episodes && (
            <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap">
              {movie.episodes}
            </span>
          )}
          <span className="absolute top-2 right-2 bg-background-50/90 text-primary-600 text-xs font-bold px-1.5 py-0.5 rounded whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        <h4 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
          {movie.title}
        </h4>
      </Link>
    );
  }

  if (variant === 'featured') {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="group relative block overflow-hidden rounded-xl cursor-pointer"
      >
        <div className="aspect-[16/7] relative">
          <img
            src={movie.imageUrl}
            alt={movie.title}
            title={`${movie.title} - 人人影院高清免费在线观看`}
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
          <div className="absolute bottom-0 left-0 p-6 md:p-8">
            <div className="flex items-center gap-2 mb-2">
              {movie.isNew && (
                <span className="bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap">
                  NEW
                </span>
              )}
              <span className="text-background-50/80 text-xs">
                {movie.year} / {movie.subcategory}
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-background-50 mb-2">
              {movie.title}
            </h3>
            <p className="text-sm text-background-50/70 max-w-lg line-clamp-2">
              {movie.description}
            </p>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
        <img
          src={movie.imageUrl}
          alt={movie.title}
          title={`${movie.title} - 人人影院高清免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 right-2 bg-background-50/90 text-primary-600 text-xs font-bold px-1.5 py-0.5 rounded whitespace-nowrap">
          {movie.rating}
        </div>
        {movie.episodes && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap">
            {movie.episodes}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="block w-full text-center bg-primary-500 text-background-50 text-sm font-medium py-2 rounded-md whitespace-nowrap">
            立即观看
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{movie.year}</span>
        <span>·</span>
        <span>{movie.subcategory}</span>
        {movie.isNew && (
          <>
            <span>·</span>
            <span className="text-accent-500 font-medium">最新</span>
          </>
        )}
      </div>
    </Link>
  );
}